import React, { Component } from "react";
import './PlaySongs.css';
import MusicList from "./Music-List";
import Hls from 'hls.js';
import axios from '../tokenInterceptor';

class PlaySongs extends Component {
    audio =null;
    constructor(props) {
        super(props);
        this.state = {
            selectedMusicData: {},
            playButton: true,
            stopButton: false,
            musicLoad: false
        }
        this.playStatus =0;
        this.hls = null;
        this.tokenGetTime=null;
    }

    componentWillMount =()=>{
        
    }

    componentWillReceiveProps = (props) => {
        if(this.audio ==  null) {
            this.setState({ selectedMusicData: props.music },()=>this.playMusic())
        } else {
            this.setState({ selectedMusicData: props.music },()=>{
                Promise.resolve(this.stopMusic()).then(()=>this.playMusic());
            });
            // this.stopMusic();
        }
    }

    playMusic = () => {
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            console.log("inside if");
            this.setState({musicLoad: true});
            if (this.playStatus == 0) {
                this.audio = new Audio();
                this.setState({stopButton: true, playButton: false});
                this.hlsLibFunction(this.audio);
                this.endSong(this.audio);
                this.progressBarFun(this.audio);
                this.setTime(this.audio);
            } else {
                if (this.audio.paused) {
                    this.setState({stopButton: true, playButton: false, musicLoad: false});
                    this.mediaPlay();
                } else {
                    this.setState({stopButton: false, playButton: true, musicLoad: false});
                    this.audio.pause();
                }
                this.playStatus += 1;
            }
        } else {
            console.log("inside else");
            this.generateNewAccessToken();
        }
        
    }

    hlsLibFunction =(audio)=> {
        let that = this;
        let playMedia = this.state.selectedMusicData.songUrl;
        if (Hls.isSupported()) {
            if (that.hls) {
                that.hls.destroy();
                if (that.hls.bufferTimer) {
                    clearInterval(that.hls.bufferTimer);
                    that.hls.bufferTimer = undefined;
                }
                that.hls = null;
            }
            that.hls = new Hls();
            that.hls.loadSource(playMedia);
            that.hls.attachMedia(audio);
            that.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                that.mediaPlay();
            });
            that.hls.on(Hls.Events.ERROR, function () {
                console.log("hls error");
            });
        }
    }

    mediaPlay=()=> {
        if (this.audio != null) {
            let playPromise = this.audio.play();
            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    this.setState({stopButton: true, playButton: false, musicLoad: false});
                    this.playStatus += 1;
                }).catch(error => {
                });
            }
        }
    }

    endSong =(audio)=> {
        let that = this;
        audio.onended = function () {
            that.setState({stopButton: false, playButton: true});
            audio.pause();
            audio.currentTime = 0;
            clearInterval(this.timeupdate);
            audio = null;
            that.playStatus = 0;
            document.getElementById('buffredbar').style.width = "0";
        };
    }

    progressBarFun =(audio)=> {
        audio.onprogress = function (e) {
            let bufferedend;
            for (let i = 0; i < audio.buffered.length; i++) {
                bufferedend = audio.buffered.end(i);
            }
            if (bufferedend <= audio.duration) {
                document.getElementById('buffredbar').style.width = ((290 / 100) * ((bufferedend / audio.duration) * 100)) + 'px';
            }
        }
    }

    setTime =(audio)=> {
        this.timeupdate = setInterval(function (e) {
            if (audio != null) {
                if (audio.currentTime != null && audio.duration != null) {
                    let cur = audio.currentTime;
                    let dur = audio.duration;
                    let curStr = String(Math.floor(cur / 60)).padStart(1) + ":" + String(Math.round(cur) % 60).padStart(2, "0")
                    let durStr = String(Math.floor(dur / 60)).padStart(1) + ":" + String(Math.round(dur) % 60).padStart(2, "0")
                    if (curStr == "NaN:NaN" || durStr == "NaN:NaN") {
                        curStr = "";
                        durStr = "";
                    }
                    // document.getElementsByClassName('a20-left-semibold-primary51')[0].textContent = curStr;
                    // document.getElementsByClassName('a20-right-regular-black1')[0].textContent = durStr;
                    document.getElementById('progress').style.width = ((290 / 100) * ((audio.currentTime / audio.duration) * 100)) + 'px';
                    let TimeRanges = audio.buffered;
                }
            }
        }, 700);
    }

    stopMusic =()=> {
        this.audio.pause();
        this.setState({playButton: true, stopButton: false});
        clearInterval(this.timeupdate);
        // document.getElementsByClassName('a20-left-semibold-primary51')[0].textContent = "";
        // document.getElementsByClassName('a20-right-regular-black1')[0].textContent = "";
        this.playStatus = 0;
        document.getElementById('progress').style.width = "0";
        document.getElementById('buffredbar').style.width = "0";
    }

    generateNewAccessToken() {
        var requestObject = {
          "grant_type": "refresh_token",
          "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status ==200) {
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
            } else {
                console.log("unable to generate token");
            }
        });
    }

    render() {
        return <>
            <div style={{position:"relative",bottom:0,background:"white",width:"50%",left:"257px",height:"70px"}}>
                <div style={{position:"relative"}}>
                <div className="music-title" style={{position:"absolute",top:0,left:0,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{this.state.selectedMusicData.title}</div>
                    <div className="music-sub-title" style={{position:"absolute",left:0,top:"25px",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{this.state.selectedMusicData.artist}</div>
                    <div className="group41" style={{position:"relative",top:"35px"}}>
                        <div className="shapes-pill" style={{position:"absolute",zIndex:1}}>
                                    <img src={require("../assets/images/icons/radio  homerectanglegray.png")} name="buffredbarImage" id="buffredbar" className="rectangle4_1" style={{ "width": "0px" }} />
                        </div>
                        <div className="color5" style={{position:"absolute",zIndex:5}}>
                            <img src={require("../assets/images/icons/radio  homerectangle.png")} name="barImage" id="progress" className="rectangle5"
                                 style={{ "width": "0px",height:"6px" }} />
                        </div>
                    </div>
                    {
                        this.state.musicLoad && (
                            <img  src={require("../assets/images/icons/gif-load.gif")} name="loadingImage" className="image-circle"/>
                        )
                    }
                {
                    this.state.playButton && (
                        <img src={require("../assets/images/icons/radio  home iconaudiovoice  4.png")}
                             name="playbutton" className="icon-audio-voice4" style={{position:"absolute",right:"10px",pointer:"cursor",top:"30px"}}
                             onClick={this.playMusic}
                        />
                    )
                }
                    {
                        this.state.stopButton && (
                            <img src={require("../assets/images/icons/audio apps  spotify  home copy 2 iconaudiovoice  1.png")}
                                 className="icon-audio-voice4"
                                 style={{position:"absolute",right:"10px",pointer:"cursor",top:"30px"}}
                                 onClick={this.playMusic}
                                 name="playbutton"  />
                        )
                    }
                </div>
            </div>
    </>;
        return (
            <>
                <div className="musicapp_frame">
                    <div className="radio-home">
                        <div>
                            <div className="group">
                                <div className="group1" onClick={this.playMusic}>
                                    <img src={require("../assets/images/icons/radio  home fillprimary 1  4.png")} className="fill-primary14" />
                                    {
                                        this.state.playButton && (
                                            <img src={require("../assets/images/icons/radio  home iconaudiovoice  4.png")} name="playbutton" className="icon-audio-voice4" />
                                        )
                                    }
                                    {
                                        this.state.stopButton && (
                                            <img src={require("../assets/images/icons/audio apps  spotify  home copy 2 iconaudiovoice  1.png")} name="playbutton" className="icon-audio-voice4" />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="ui-media-playback-album-lockup">
                                <div className="a28-center-semibold-black">
                                    <div className="a-aaaaa"></div>
                                </div>
                                <div className="group31">
                                    <div className="group8">
                                        <div className="a20-center-regular-gray4">
                                            <div className="a20-right-regular-gray4"></div>
                                        </div>
                                        <div className="a20-center-regular-gray4-copy">
                                            <div className="a-aaaaa1"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="images">
                                    <div className="image-square">
                                        <div className="elevation-square">
                                            <div className="shape2">
                                                <div className="mask3"></div>
                                                <div className="color3">
                                                    <div className="rectangle3"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="image-square1">
                                            <div className="mask4"></div>
                                            <div className="bitmap"></div>
                                        </div>
                                    </div>
                                    {/*<img src={this.state.selectedMusicData.imageUrl} name="loadingImage" className="image-circle" />*/}
                                </div>
                                <div className="music-title">{this.state.selectedMusicData.title}</div>
                                <div className="music-sub-title">{this.state.selectedMusicData.artist}</div>
                                <div className="group41">
                                    <div className="shapes-pill">
                                        <div className="color4">
                                            <div className="rectangle4">
                                                <img src={require("../assets/images/icons/radio  homerectanglegray.png")} name="buffredbarImage" id="buffredbar" className="rectangle4_1" style={{ "width": "0px" }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="color5">
                                        <img src={require("../assets/images/icons/radio  homerectangle.png")} name="barImage" id="progress" className="rectangle5" style={{ "width": "0px" }} />
                                    </div>
                                </div>
                                {
                                    this.state.musicLoad && (
                                        <img  src={require("../assets/images/icons/gif-load.gif")} name="loadingImage" className="image-circle"/>
                                    )
                                }
                                <div className="a20-left-semibold-primary5">
                                    <div className="a20-left-semibold-primary51"></div>
                                </div>
                                <div className="a20-right-regular-black">
                                    <div className="a20-right-regular-black1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default PlaySongs;
